"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeDomMetrics = void 0;
var DomMetricNames_1 = require("../enums/DomMetricNames");
function getDomMetricValues() {
    var _a;
    var _b, _c;
    var _d = __read((((_c = (_b = window.performance).getEntriesByType) === null || _c === void 0 ? void 0 : _c.call(_b, 'navigation')) || []), 1), timing = _d[0];
    if (!timing) {
        return null;
    }
    return _a = {},
        _a[DomMetricNames_1.DomMetricNames.Complete] = timing.domComplete,
        _a[DomMetricNames_1.DomMetricNames.Interactive] = timing.domInteractive,
        _a;
}
function getDeprecatedDomMetricValues() {
    var _a;
    var _b;
    var timing = (_b = window.performance) === null || _b === void 0 ? void 0 : _b.timing;
    if (!timing) {
        return null;
    }
    var navStart = timing.navigationStart;
    if (!navStart) {
        return null;
    }
    var domCompleteTime = timing.domComplete
        ? timing.domComplete - navStart
        : 0;
    var domInteractiveTime = timing.domInteractive
        ? timing.domInteractive - navStart
        : 0;
    return _a = {},
        _a[DomMetricNames_1.DomMetricNames.Complete] = domCompleteTime,
        _a[DomMetricNames_1.DomMetricNames.Interactive] = domInteractiveTime,
        _a;
}
function composeDomMetrics(params) {
    if (typeof window === 'undefined') {
        return null;
    }
    var domMetricValues = getDomMetricValues() || getDeprecatedDomMetricValues();
    if (!domMetricValues) {
        return null;
    }
    var domMetricEntries = Object.entries(domMetricValues);
    var metrics = domMetricEntries
        .filter(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return value;
    })
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return ({
            name: key,
            value: value,
            params: params,
        });
    });
    return metrics.length
        ? metrics
        : null;
}
exports.composeDomMetrics = composeDomMetrics;
//# sourceMappingURL=domMetrics.js.map